import styled from 'styled-components'
import Flex from 'components/priority/Flex/Flex'
import colors from 'utils/styling/colors'

export const StyledFlex = styled(Flex)`
  background-color: rgba(${colors('pinturaBackground')});
`
